module.exports = __webpack_public_path__ + "img/mla.ddb60f1b.jpg";